<template>
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <h6 class="col-9 col-xl-10 mb-0">
            {{ instance.name }}
          </h6>

          <div class="col-3 col-xl-2">
            <div class="row">
              <div class="col p-0">
                <toggle-option-element :instance="instance"
                  :field="{ key: 'status'}"
                  :http="http"
                  :entity="entity"
                  :classes="['fa fa-eye','fa fa-eye-slash']"
                  :labels="['Visível', 'Oculto']">
                </toggle-option-element>
              </div>

              <div class="col p-0">
                <router-link :to="{
                  name: 'manageables.nested.edit',
                  params: {
                    entity: 'bl-story',
                    id: instance.process_id,
                    nestedEntity: 'bl-story-categories',
                    nestedId: instance.id
                  }
                }">

                  <i class="fa fa-edit" v-b-tooltip.hover title="Editar"></i>
                </router-link>
              </div>

              <div class="col">
                <delete-element :instance="instance"
                  :http="http"
                  :entity="entity"
                  @refresh="$emit('item-removed', instance)"></delete-element>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    instance: {
      type: Object,
      default () {
        return {}
      }
    },

    entity: {
      type: Object,
      required: true
    },

    http: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      //
    }
  },

  computed: {
    //
  },

  methods: {
    //
  }
}
</script>

<style lang="sass" scoped>
  .fa
    position: relative
    z-index: 9999
</style>



// WEBPACK FOOTER //
// src/components/forms/Bl/StoryCategoryCard.vue